import { render, staticRenderFns } from "./InstitutionList.vue?vue&type=template&id=0cdcb138&scoped=true&"
import script from "./InstitutionList.vue?vue&type=script&lang=js&"
export * from "./InstitutionList.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionList.vue?vue&type=style&index=0&id=0cdcb138&lang=scss&scoped=true&"
import style1 from "./InstitutionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdcb138",
  null
  
)

export default component.exports